<template>
  <b-card
    :class="`bg-${status.color}`"
    class="bg-lighten-2"
    text-variant="white"
  >
    <b-card-title class="text-white">
      <div class="d-flex justify-content-between">
        {{ title }}
        <b-dropdown variant="flat-primary" no-caret :right="true">
          <template #button-content>
            <feather-icon
              icon="MoreVerticalIcon"
              size="18"
              class="align-middle text-white"
            />
          </template>
          <b-dropdown-item variant="primary" @click="showUpdateModal">
            <feather-icon icon="EditIcon" />
            <span class="align-middle ml-50">تعديل</span>
          </b-dropdown-item>
          <b-dropdown-item variant="danger" @click="onDelete">
            <feather-icon icon="Trash2Icon" />
            <span class="align-middle ml-50">حذف</span>
          </b-dropdown-item>
        </b-dropdown>
        <!-- <feather-icon
          size="22"
          class="ml-auto"
          :icon="icon"
          style="cursor: pointer"
          @click="showUpdateModal"
        /> -->
      </div>
    </b-card-title>
    <b-card-sub-title sub-title-text-variant="light">
      {{ status.name }}
    </b-card-sub-title>

    <hr />

    <b-card-text v-html="description"> </b-card-text>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BCardSubTitle,
  BDropdown,
  BDropdownItem,
  BButton,
} from "bootstrap-vue";
import { mapActions } from "vuex";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardTitle,
    BCardSubTitle,
    BDropdown,
    BDropdownItem,
    BButton,
  },
  props: {
    id: Number,
    title: String,
    description: String,
    icon: String,
    is_active: Boolean,
    service_id: Number,
    status: Object,
    status_id: Number,
    service: Object,
    service_frequency: Object,
    providing_date: String,
    resumption_date: String,
  },

  methods: {
    showUpdateModal() {
      const toEmit = {
        id: this.id,
        title: this.title,
        description: this.description,
        icon: this.icon,
        is_active: this.is_active,
        service_id: this.service_id,
        status: this.status,
        status_id: this.status_id,
        service: this.service,
        service_frequency: this.service_frequency,
        providing_date: this.providing_date,
        resumption_date: this.resumption_date,
      };
      this.$emit("showUpdateModal", toEmit);
    },
    ...mapActions("NgoProfile/NgoServices", ["deleteService"]),
    onDelete() {
      this.deleteService(this.id);
    },
  },
};
</script>
